import React from 'react';
import './PopularSearches.css';
import { GoArrowUpRight } from 'react-icons/go';
import magnifyingGlassIcon from '../../assets/icons/magnifyingGlass.svg';

const searches = [
  'Best colleges for MBA',
  'Best colleges for Engineering',
  'Best colleges for Medical',
  'Best colleges for Data Science',
  'Best colleges for Fashion designing',
  'Best colleges for Cloud Engineering',
  'Best colleges for Business',
  'Best colleges for BE/BTech',
  'Best colleges for BCA',
  'Best colleges for Architecture'
];

const PopularSearches = () => {
  return (
    <div className="popular-searches-wrapper">
      <section className="popular-searches-section">
        <div className="popular-header">
          <img src={magnifyingGlassIcon} alt="Search" className="search-icon-large" />
          <h2 className="popular-heading">Most popular <span className="highlight-text">Searches</span></h2>
          <div className="underline-green"></div>
        </div>
        
        <div className="popular-grid">
          {searches.map((item, index) => {
            // Extract the core term: "Best colleges for MBA" -> "MBA"
            const query = item.replace("Best colleges for ", "");
            return (
              <a key={index} href={`/college-finder?q=${encodeURIComponent(query)}`} className="popular-search-item">
                <span>{item}</span>
                <GoArrowUpRight className="arrow-icon" />
              </a>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default PopularSearches;
